import { JsonObject, JsonProperty } from 'json2typescript'

@JsonObject('ForgotUsername')
export default class ForgotUsername {
  @JsonProperty('emailAddress', String)
  emailAddress = ''
}
